import React from 'react'

export default function Api() {
  return (
    <div style={{margin:"1rem",padding:"10px",color: "#54616c",fontSize:"16px"}}>
      <p style={{textAlign:"left"}}>API Keys let you use remove.bg from within other tools or your own software.</p>
      <p style={{textAlign:"left"}}>Check out our list of tools and API to see what you can do!</p>
    </div>
  )
}
